import { gql } from "@apollo/client";

export const QUERY_FORM3454A_VERSION = gql`
  query studentForm3454A(
    $studentFormId: ID!
    $formId: ID!
    $studentId: ID!
    $schoolId: ID!
    $studentMeetingId: ID!
  ) {
    studentForm3454A(
      studentFormId: $studentFormId
      studentId: $studentId
      formId: $formId
      schoolId: $schoolId
      studentMeetingId: $studentMeetingId
    ) {
      versionId
      formId
      formDate
      studentFullName
      academicAchievement
      functionalPerformance
      cognitiveFunctioning
      communicativeStatus
      eLStatus
      linguisticChanged
      healthStatus
      hearingStatus
      motorStatus
      socialStatus
      formAction
      formStatus
    }
  }
`;
